import { SpriteSvg, SpriteSvgType } from '../../../sprite-svg';

export const renderExpandIconDownRight = (
  isExpand: boolean,
  expandedText?: string,
  foldText?: string
) => {
  if (isExpand) {
    return (
      <>
        <SpriteSvg
          type={SpriteSvgType.ExpandArrow}
          width={16}
          height={16}
          style={{ transform: 'rotate(90deg)' }}
        />
        {foldText || ''}
      </>
    );
  }
  return (
    <>
      <SpriteSvg type={SpriteSvgType.ExpandArrow} width={16} height={16} />
      {expandedText || ''}
    </>
  );
};
